/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import personTranslations from "./personTranslations";
import { prosecutionTranslations } from "./prosecutionTranslations";
import litigationCaseTranslations from "./litigationCaseTranslations";

const trafficAccidentTranslations = {
  label: "Verkehrsunfall",
  ...litigationCaseTranslations,
  additionalClaimText: {
    label: "Zusatztext Forderung",
  },
  additionalIssueDescriptionText: {
    label: "Zusatztext Schilderung Sachverhalt",
  },
  clientLegalRepresentative: personTranslations,
  responsibleProsecution: prosecutionTranslations,
  prosecutionReference: {
    label: "Aktenzeichen Staatsanwaltschaft",
  },
  contractDate: {
    label: "Vertragsabschluss am",
  },
  typeOfDamage: {
    label: "Art des Schadens",
    values: {
      vehicle: "Schaden am Fahrzeug",
      person: "Personenschaden",
      vehicleAndPerson: "Schaden am Fahrzeug und Personenschaden",
      other: "Anderer Sachschaden",
    },
  },
  typeOfAccident: {
    label: "Art des Unfalls",
    values: {
      rearEndCollision: "Auffahrunfall",
      laneChangeCollision: "Spurwechselkollision",
      parking: "Ein- / Ausparken",
      other: "Sonstiges / Unklar",
    },
  },
  courseOfEvents: {
    label: "Unfallhergang Mandantschaft",
  },
  courseOfEventsLawFirm: {
    label: "Unfallschilderung Kanzlei",
  },
  claimsForDamages: {
    label: "Schadensersatzansprüche",
    values: {
      repairCosts: "Reparaturkosten",
      replacementCosts: "Wiederbeschaffungsaufwand",
      lossOfUse: "Nutzungsausfall",
      rentalCarCosts: "Mietwagenkosten",
      depreciation: "Wertminderung",
      expertFees: "Sachverständigengebühren",
      expensesFlatFee: "Auslagenpauschale",
      deregistrationCosts: "Abmeldekosten",
      registrationCosts: "Anmeldekosten",
      towingCosts: "Abschleppkosten",
      storageCosts: "Standkosten",
      financingCosts: "Finanzierungskosten",
      other: "Sonstiges",
    },
  },
  extrajudicialCommunicationSent: {
    label: "Schreiben an KFZ-Haftpflicht am",
  },
  extrajudicialCommunicationDeadline: {
    label: "Gesetzte Frist für KFZ-Haftpflicht",
  },
  trialWanted: {
    label: "Gerichtsverfahren gewünscht",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  extrajudicialReaction: {
    label: "Reaktion KFZ-Haftpflicht",
    values: {
      noReaction: "Keine Reaktion",
      fullyAgreed: "Forderung wird vollständig erfüllt/aufgegeben",
      partiallyAgreed: "Forderung wird teilweise erfüllt/aufgegeben",
      disagreed: "Forderung wird nicht erfüllt/aufrechterhalten",
    },
    enforceClaim: {
      label: "Reaktion KFZ-Haftpflicht",
      values: {
        noReaction: "Keine Reaktion",
        fullyAgreed: "Schaden wird voll reguliert",
        partiallyAgreed: "Schaden wird gequotelt",
        disagreed: "Schaden wird nicht reguliert",
      },
    },
  },
  extrajudicialRecommendation: {
    label: "Empfehlung weiteres Vorgehen",
    values: {
      agreementDone: "Vollständige Regulierung erzielt",
      quoteNoLawsuitRecommendation: "Quote - keine Klageempfehlung",
      quoteLawsuitRecommendation: "Quote - Klageempfehlung",
      lawsuit: "Klage einreichen",
      individualText: "Individuelle Empfehlung",
    },
  },
  extrajudicialRecommendationText: {
    label: "Zusatztext Empfehlung",
  },
  finalClaimStatusClient: {
    label: "Stand Forderung aus Sicht Mandantschaft",
    values: {
      fullyAgreed: "Voll erledigt",
      partiallyAgreed: "Teilweise erledigt",
      notAgreed: "Nicht erledigt",
      noReaction: "Keine erledigt",
    },
    enforceClaim: {
      label: "Stand Forderung aus Sicht Mandantschaft",
      values: {
        fullyAgreed: "Voll erfüllt",
        partiallyAgreed: "Teilweise erfüllt",
        notAgreed: "Nicht erfüllt",
        noReaction: "Keine Reaktion",
      },
    },
  },
  finalProcessFeedbackClient: {
    label: "Finale Entscheidung Mandantschaft",
    values: {
      agreement: "Fall abschließen",
      lawsuit: "Gerichtsverfahren",
    },
    enforceClaim: {
      label: "Finale Entscheidung Mandantschaft",
      values: {
        agreement: "Forderung erledigt/zurücknehmen",
        lawsuit: "Forderung einklagen",
      },
    },
  },
  extrajudicialReactionReceived: {
    label: "Reaktion der KFZ-Haftpflicht am",
  },
  claimedAmountLawFirm: {
    label: "Forderungsbetrag",
  },
  licensePlateOpposingParty: {
    label: "KFZ-Kennzeichen Unfallgegner",
  },
  vehicleMake: {
    label: "Marke Fahrzeug",
  },
  vehicleModel: {
    label: "Modell Fahrzeug",
  },
  vehicleId: {
    label: "Fahrzeugidentifikationsnr.",
  },
  licensePlateClientVehicle: {
    label: "KFZ-Kennzeichen eigenes Fahrzeug",
  },
  accidentAddress: {
    streetAddress: {
      label: "Straße und Hausnummer - Unfallort",
    },
    postalCode: {
      label: "PLZ - Unfallort",
    },
    addressLocality: {
      label: "Ort - Unfallort",
    },
  },
  accidentDate: {
    label: "Datum des Unfalls",
  },
  accidentTime: {
    label: "Unfallzeitpunkt",
  },
  opposingInsurancePolicyNumber: {
    label: "Versicherungsnummer KFZ-Haftpflicht",
  },
  opposingCaseReferenceNumber: {
    label: "Schadennummer KFZ-Haftpflicht",
  },
  descriptionInjuries: {
    label: "Beschreibung Personenschaden",
  },
  opposingCarLiabilityInsurance: {
    organization: {
      label: "KFZ-Haftpflichtversicherer",
    },
  },
  descriptionDamage: {
    label: "Beschreibung Sachschaden",
  },
  driverOfClientVehicle: {
    label: "Fahrer eigenes Fahrzeug",
    values: {
      client: "Ich selbst",
      other: "Eine andere Person",
      nobody: "Niemand (Fahrzeug geparkt)",
    },
  },
  driverPerson: {
    gender: {
      label: "Anrede - Fahrer",
      values: {
        male: "Herr",
        female: "Frau",
        diverse: "Divers",
      },
    },
    givenName: {
      label: "Vorname - Fahrer",
    },
    familyName: {
      label: " Nachname - Fahrer",
    },
    residenceAddress: {
      streetAddress: {
        label: "Straße und Hausnummer - Fahrer",
      },
      postalCode: {
        label: "PLZ - Fahrer",
      },
      addressLocality: {
        label: "Ort - Fahrer",
      },
    },
  },
  legalExpenseInsurance: {
    label: "Rechtsschutz Verkehr",
  },
};

export default trafficAccidentTranslations;
